import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { QuoteDataCaptureService, FormValidationsService, ModalScroll, SERVICE_END_POINT, DealPartnerFunctionalityService, AnalyticsService, CURRENT_ENVIROMENT, UIRulesService, AuthService } from '../../../../shared';
import * as UserDataConfig from '../../config/user-data.config';
import { AppState } from '../../../../store/state/app.state';
import { Observable, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ProductChoice } from '../../../../model/ngrx/Product-Choice.model';
import * as ProductChoiceActions from '../../../../store/actions/product-choice.actions';
import * as RefNumberActions from '../../../../store/actions/reference-number.actions';
import * as ReqQuoteCalcActions from '../../../../store/actions/request-quote-calculation.actions';
import { AlertModal } from 'src/app/model/alert';
import { RefNo } from 'src/app/model/ngrx';
import { UtilService } from '../../../../shared';
import { DependantDetails } from '../../../../model/ngrx/dependant-details.model';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import * as resDataCalculationActions from '../../../../store/actions/response-quote-calculation.actions';
import { ComponentTypes, DisplayRuleToBeApplied } from 'src/app/model/ui-rule-response-model';
import { ComponentAttributes, AttributeReqPayLoad } from 'src/app/model/ui-rule-request-payload';
import { ATTRIBUTE_NAMES_CONST } from 'src/app/shared/services/api-constants/attribute-names-constant';
import { HttpErrorResponse } from '@angular/common/http';
import { AttributeIdAndStyle } from 'src/app/model/ui.attribute.style.model';
import { ATTRIBUTE_NAME_ID } from 'src/app/pages/user-details/config/ceding-fund-attribute-id';
import { DatePipe } from '@angular/common';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ConfigLoaderService } from 'src/app/shared/services/api-services/configLoader.service';


@Component({
  selector: 'app-product-choice',
  templateUrl: './product-choice.component.html',
  styleUrls: ['./product-choice.component.scss']
})
export class ProductChoiceComponent implements OnInit, OnDestroy {
  public get router(): Router {
    return this._router;
  }
  public set router(value: Router) {
    this._router = value;
  }

  protected urlLink: string;
  public contentData: any;
  public cmsDataQuestionPensionPot: any;
  public cmsDataQuestionflexwith: any;
  public cmsDataQuestionFinancialDependants: any;
  public cmsDataQuestionWithdrawingMoney: any;
  public userInputDetail = UserDataConfig.ElementsConfig;
  userForm: UntypedFormGroup;
  public productChoiceForm: UntypedFormGroup;
  public productOption: any[];
  productSelectedCode: string;
  fundingSource: string;
  availableProductObject: any;
  availableProductArray: any[] = [];
  widthsize = 100;
  isProductSelected = false;
  selectedProductCode = '';
  selectedProductName = '';
  productsChoice: any;
  productsChoiceStore: Observable<any[]>;
  postProductChoice: ProductChoice;
  postProductsChoiceStore: Observable<ProductChoice[]>;
  reqQuoteCalculationStore: Observable<any[]>;
  resQuoteCalculationStore: Observable<any[]>;
  dependantDetailsStore: Observable<DependantDetails[]>;
  dependantDetailsData: DependantDetails;
  yourOptions: any = null;
  yourOptionsResponse: any = null;
  ProductErrorValidatorFlag = false;
  public displayAlert = false;
  previousActiveElement: any;
  private subscriptn: Subscription;
  private productChoicValueSub: Subscription;
  private subscripBeforeLogin: Subscription;
  public alertModalConfig: AlertModal = new AlertModal('alert', 'A message you should pay attention to', '', 'OK', '', '');
  private subscripSaveProgress: Subscription;
  // yourPensionStore: Observable<YourPension[]>;
  // pensionForm: YourPension;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  editMode: boolean;
  productFormEdit: ProductChoice;
  cmsAlertData: any;
  // tslint:disable-next-line:max-line-length
  protected alertModalEditConfig: AlertModal;
  private subscripLogout: Subscription;
  public CMSData;
  screenName;
  productChoiceCompRules: ComponentTypes;
  public productTypes = [];
  public endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute,
    private _router: Router, private quoteDatacaptureService: QuoteDataCaptureService,
    private store: Store<AppState>, private btnFocusOnModalClose: ModalScroll,
    private utilService: UtilService,
    private dealPartnerFunctionalityService: DealPartnerFunctionalityService,
    public el: ElementRef, private analyticsService: AnalyticsService, private uiRulesService: UIRulesService,
    public datePipe: DatePipe, private authService: AuthService, private configLoaderService: ConfigLoaderService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.productChoice;
    this.cmsAlertData = this.activatedRoute.snapshot.data.contentData;
    this.cmsDataQuestionPensionPot = JSON.parse(JSON.stringify(this.contentData.pensionPotQuestion));
    this.cmsDataQuestionflexwith = JSON.parse(JSON.stringify(this.contentData.lumpSumsQuestion));
    this.cmsDataQuestionFinancialDependants = JSON.parse(JSON.stringify(this.contentData.financialDependantsQuestion));
    this.cmsDataQuestionWithdrawingMoney = JSON.parse(JSON.stringify(this.contentData.withdrawingMoneyQuestion));
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.productsChoiceStore = store.select(STORE_VAL.quote_capture);
    this.productsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.productsChoice = res[0];
      } else if (this.productChoiceForm && !this.quoteDatacaptureService.checkIfObjEmpty(res)) {
        this.productChoiceForm.reset();
      }
    });

    this.postProductsChoiceStore = store.select(STORE_VAL.product_choice);
    this.postProductsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.postProductChoice = res[0];
      }
    });



    this.reqQuoteCalculationStore = store.select(STORE_VAL.req_quote_calculation);
    this.reqQuoteCalculationStore.subscribe(res => {
      if (!this.quoteDatacaptureService.checkIfObjEmpty(res) && res.length > 0) {
        this.yourOptions = res[0];
      } else {
        this.yourOptions = null;
      }
    });

    this.resQuoteCalculationStore = store.select(STORE_VAL.quote_calculation);
    this.resQuoteCalculationStore.subscribe(res => {
      if (res.length > 0) {
        this.yourOptionsResponse = res[0];
      } else if (!this.quoteDatacaptureService.checkIfObjEmpty(res)){
        this.yourOptionsResponse = null;
      }
    });

    this.dependantDetailsStore = store.select(STORE_VAL.dependant_details);
    this.dependantDetailsStore.subscribe(res => {
      if (res.length > 0) {
        this.dependantDetailsData = res[0];
      }
    });
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        if (this.referenceNumber && this.referenceNumber.editMode) {
          this.editMode = true;
          this.userInputDetail.buttonConfig['label'] = 'Done';
          this.userInputDetail.buttonConfig['name'] = 'Done';
          this.productFormEdit = JSON.parse(JSON.stringify(this.productsChoice));
          //console.log(this.productFormEdit);
        } else {
          this.editMode = false;
          this.userInputDetail.buttonConfig['label'] = 'Next';
          this.userInputDetail.buttonConfig['name'] = 'next';
        }
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataService();
    // tslint:disable-next-line:max-line-length
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
  }

  onPageLoadFunctionality() {
    this.focusOnbtn();
    UserDataConfig.ElementsConfig.productChoice.products.map(p => p.selected = false);
    this.alertModalConfig = this.contentData.modalConfigProductChange;
    // this.alertModalEditConfig.setContent(this.cmsAlertData.generalConstants.quoteChangeWarning);
    this.userFormData();
    this.setProductChoiceForm();
    if (this.productsChoice) {
      //this.fetchRefData();
      this.availableProductObject = this.productsChoice['productOptions'];
      this.fundingSource = this.productsChoice['source'];
      this.createControlDynamic();
      this.availableProduct();
      if (this.availableProductObject) {
        // this.widthsize = 95 / this.availableProductObject.split(',').length;
          this.widthsize = 90 / this.availableProductObject.split(',').length; //changed for mobile center alignment
        if (this.availableProductObject.split(',').length === 1) {
        }
        this.productOption = this.contentData.products.filter(p => this.availableProductObject.split(',').indexOf(p.productCode) >= 0);
      }
      // now need to set the value from store if product is available
      // tslint:disable-next-line: max-line-length
      if (this.postProductChoice && this.postProductChoice.selectedProduct !== '' && this.postProductChoice.source !== '' && this.postProductChoice.source === this.fundingSource) {
        this.productChoiceForm.controls.pensionPotQues.setValue(this.postProductChoice.pensionPotQues);
        this.productChoiceForm.controls.flexwithQues.setValue(this.postProductChoice.flexwithQues);
        this.productChoiceForm.controls.financialDependantsQues.setValue(this.postProductChoice.financialDependantsQues);
        this.productChoiceForm.controls.withdrawingMoneyQues.setValue(this.postProductChoice.withdrawingMoneyQues);
        this.onProductSelected({ code: this.postProductChoice.selectedProduct, value: true }, false);
      } else {
        if (this.postProductChoice && this.postProductChoice.selectedProduct !== '') {
          this.onProductSelected({ code: this.postProductChoice.selectedProduct, value: false }, false);
        }
      }
    }
  }

  ngOnDestroy() {

    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.productChoicValueSub) {
      this.productChoicValueSub.unsubscribe();
    }
  }

  prepareReqPayloadProductChoice(): ComponentAttributes {
    let selectedSource: string = this.productsChoice && this.productsChoice.source ? this.productsChoice.source : '';
    let productCode: string = this.productsChoice && this.productsChoice.fundModel && this.productsChoice.fundModel[0] &&
      this.productsChoice.fundModel[0].policies && this.productsChoice.fundModel[0].policies[0] &&
      this.productsChoice.fundModel[0].policies[0].productCode ? this.productsChoice.fundModel[0].policies[0].productCode : null;
    let channelObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.channel, 'D');
    let customerSourceObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.channelSource, 'D' + selectedSource);
    let cedingProviderObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.cedingProvider, selectedSource);
    let productCodeObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.productCode, productCode);
    let customerNeedObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.customerNeed, 'RT');
    let referenceDate: string;
    if (this.productsChoice) {
      referenceDate = this.productsChoice && this.productsChoice['quoteBasis'] && this.productsChoice['quoteBasis']['commencementDate'] ?
        this.productsChoice['quoteBasis']['commencementDate'] : this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    } else {
      referenceDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let referenceDateObj = new AttributeReqPayLoad(ATTRIBUTE_NAMES_CONST.referenceDate, referenceDate);
    if (productCode) {
      let compObjproductChoice = new ComponentAttributes('DCJproductOptions', [channelObj, customerNeedObj, customerSourceObj, productCodeObj, cedingProviderObj, referenceDateObj]);
      return compObjproductChoice;
    } else {
      let compObjproductChoice = new ComponentAttributes('DCJproductOptions', [channelObj, customerNeedObj, customerSourceObj, cedingProviderObj, referenceDateObj]);
      return compObjproductChoice;
    }
  }

  fetchRefData() {
    let uiRulesJsonUrl = this.endPoints['productChoiceUiRulesJsonUrl'];
    let reqPayload = this.prepareReqPayloadProductChoice();
    let payload: any;
    this.quoteDatacaptureService.fetchUIResponseJson(uiRulesJsonUrl, reqPayload).subscribe((data: ComponentTypes) => {
      if (data) {
        this.productChoiceCompRules = data;
        this.setProductOptionsConfig();
      }
    },
      (err: HttpErrorResponse) => {
        //console.log(err);
      });
  }

  setProductOptionsConfig() {
    let productToFetch: DisplayRuleToBeApplied = new DisplayRuleToBeApplied('channelSource:customerNeed', 'D' + this.productsChoice.source + ':' + 'RT');
    let productConfig = this.uiRulesService.getUIRulesForgivenAttribute('productType',
      this.productChoiceCompRules);
    let productChoiceConfig = this.uiRulesService.createMapperForDropdown(productConfig, null, null, null);
    productChoiceConfig.options.forEach(val => {
      this.productTypes.push(val.code);
    });

    let pensionFundVal = this.productsChoice && this.productsChoice['benefitBasis'] && this.productsChoice['benefitBasis'][0] && 
    this.productsChoice['benefitBasis'][0]['pensionFund'] ? this.productsChoice['benefitBasis'][0]['pensionFund'] : null;
    
    let filteredProductType = [];
    let pensionFundConfig = this.uiRulesService.getUIRulesForgivenAttribute('DCJPensionFund',
      this.productChoiceCompRules);
    pensionFundConfig.refList.forEach(val => {
      if(this.productTypes.includes(val['refAttributeCode']) && pensionFundVal >= val['minValue'] && pensionFundVal <= val['maxValue']) {
        filteredProductType.push(val['refAttributeCode'])
      }
    });
    if (filteredProductType) {
      this.productOption = this.contentData.products.filter(p => Object.values(filteredProductType).indexOf(p.productCode) >= 0);
    }
  }

  saveAfterLogin() {
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully());
  }

  saveProgress() {
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveFormValues() {
    this.store.dispatch(new ProductChoiceActions.RemoveProductChoice(0));
    this.store.dispatch(new ProductChoiceActions.AddProductChoice({
      selectedProduct: this.selectedProductCode,
      productName: this.selectedProductName, pensionPotQues: this.productChoiceForm.controls.pensionPotQues.value,
      flexwithQues: this.productChoiceForm.controls.flexwithQues.value,
      financialDependantsQues: this.productChoiceForm.controls.financialDependantsQues.value,
      withdrawingMoneyQues: this.productChoiceForm.controls.withdrawingMoneyQues.value,
      riskAndStaticQuestion: this.createQuestionarray(),
      source: this.productsChoice['source'],
      productOptions: this.productsChoice['productOptions']
    }));
  }
  showNext(formChanged) {
    if (formChanged) {
      // this.editMode = false;
      this.userInputDetail.buttonConfig['label'] = 'Next';
      this.userInputDetail.buttonConfig['name'] = 'Next';
    } else {
      this.userInputDetail.buttonConfig['label'] = 'Done';
      this.userInputDetail.buttonConfig['name'] = 'Done';
    }
  }
  availableProduct() {
    if (this.availableProductObject) {
      this.availableProductObject.split(',').forEach(p => {
        const prod: any[] = this.contentData.products.filter(pr => pr.productCode === p);
        if (prod.length > 0) {
          this.availableProductArray.push(prod);
        }
      });
    }
  }

  userFormData = () => {
    //  this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      next: ['']
    });
  }
  setProductChoiceForm() {
    this.productChoiceForm = this.fb.group({
      pensionPotQues: [null, Validators.required],
      flexwithQues: [null, Validators.required],
      financialDependantsQues: [null, Validators.required],
      withdrawingMoneyQues: [null]
    });
  }

  createControlDynamic() {
    const tempFormGroup = this.fb.group({});
    if (this.availableProductObject) {
      // tslint:disable-next-line: max-line-length
      const controls: any[] = this.userInputDetail.productChoice.products.filter(p => this.availableProductObject.split(',').indexOf(p.productCode) >= 0);
      controls.forEach(item => {
        this.productChoiceForm.addControl(item.controlName, this.fb.control(''));
      });
    }


  }

  onProductSelected(value, productChangedOnReview) {
    // //console.log((this.isProductSelected && value.value) && this.createQuestionarray().length !== null)
    // //console.log(this.createQuestionarray().length)
    if ((this.isProductSelected && value.value) && this.createQuestionarray().length !== 0) {
      this.displayAlert = true;
    }
    //console.log(this.productChoiceForm);
    const refproductChoiceForm = this.productChoiceForm.controls.pensionPotQues;
    this.userInputDetail.productChoice.products.forEach(p => {
      if (p.productCode === value.code && value.value) {
        this.selectedProductCode = value.code;
        this.selectedProductName = p.productName;
        p.selected = true;
      } else {
        p.selected = false;
      }
    });
    if (value.value) {
      this.isProductSelected = true;
    } else {
      this.isProductSelected = false;
    }
    const selectedProduct = this.productOption.find(p => {
      return p.productCode === value.code;
    });
    selectedProduct.questionResponse.forEach(resQues => {
      this.contentData[Object.keys(resQues)[0]].questionOptions.forEach(q => {
        resQues[Object.keys(resQues)[0]].forEach(res => {
          if (q.code === res.questionCode) {
            q.infoText = res.infoText;
            q.infoClass = res.infoClass;
          }
        });
      });
    });
    if (value.value) {
      this.ProductErrorValidatorFlag = !this.isProductSelected;
    }
    if (this.selectedProductCode === 'H' || this.selectedProductCode === 'G') {
      this.productChoiceForm.controls.withdrawingMoneyQues.setValidators(Validators.required);
      this.productChoiceForm.controls.withdrawingMoneyQues.updateValueAndValidity();
    } else {
      this.productChoiceForm.controls.withdrawingMoneyQues.setValidators(null);
      this.productChoiceForm.controls.withdrawingMoneyQues.updateValueAndValidity();
    }
    this.cmsDataQuestionPensionPot = JSON.parse(JSON.stringify(this.contentData.pensionPotQuestion));
    this.cmsDataQuestionflexwith = JSON.parse(JSON.stringify(this.contentData.lumpSumsQuestion));
    this.cmsDataQuestionFinancialDependants = JSON.parse(JSON.stringify(this.contentData.financialDependantsQuestion));
    this.cmsDataQuestionWithdrawingMoney = JSON.parse(JSON.stringify(this.contentData.withdrawingMoneyQuestion));

    // ----------------------------------------------------------------------------------------------
    if (this.isProductSelected && value.value) {
      if (this.postProductChoice) {
        if (this.postProductChoice.selectedProduct || this.selectedProductCode !== '') {
          if (this.selectedProductCode === 'C') {
            // tslint:disable-next-line:max-line-length
            // if (this.dependantDetailsData && this.dependantDetailsData.dependantQuestion === 'Y') {
            //   this.utilService.refreshBreadcrumb({hideDependatDetails: false});
            // }
            // tslint:disable-next-line:max-line-length
            this.utilService.refreshBreadcrumb({ hidden: false });
            this.urlLink = MEDICAL_UW_URL.annuitant.lifestyle;
          } else if (this.selectedProductCode === 'H') {
            // tslint:disable-next-line:max-line-length
            // if (this.dependantDetailsData && this.dependantDetailsData.dependantQuestion === 'Y') {
            //   this.utilService.refreshBreadcrumb({hideDependatDetails: true});
            // }
            this.utilService.refreshBreadcrumb({ ftrpcorpBreadCrum: true });
            this.urlLink = '/quote/your-product-options';
          } else if (this.selectedProductCode === 'G') {
            // tslint:disable-next-line:max-line-length
            // if (this.dependantDetailsData && this.dependantDetailsData.dependantQuestion === 'Y') {
            //   this.utilService.refreshBreadcrumb({hideDependatDetails: true});
            // }
            this.utilService.refreshBreadcrumb({ ftrpcorpBreadCrum: true });
            this.urlLink = '/quote/your-product-options';
          }
        }
      } else if (!this.postProductChoice) {
        if (this.selectedProductCode === 'C') {
          this.utilService.refreshBreadcrumb({ hidden: false });
          this.urlLink = MEDICAL_UW_URL.annuitant.lifestyle;
        } else if (this.selectedProductCode === 'H') {
          this.utilService.refreshBreadcrumb({ ftrpcorpBreadCrum: true });
          this.urlLink = '/quote/your-product-options';
        } else if (this.selectedProductCode === 'G') {
          this.utilService.refreshBreadcrumb({ ftrpcorpBreadCrum: true });
          this.urlLink = '/quote/your-product-options';
        }
      }

      if (this.yourOptions) {
        //console.log('Your Options ->', this.yourOptions);
        //console.log('Playground Data is Present ; postProductChoice ->', this.postProductChoice);
      } else {
        //console.log('Your Options ->', this.yourOptions);
        //console.log(' No Playground Data ; postProductChoice ->', this.postProductChoice);
      }
    }

    // ------------------------------------------------------------------------------------------------
    if (productChangedOnReview) {
      let formChanged;
      // this.productChoicValueSub  =  this.productChoiceForm.controls['chkPensionAnnuity'].valueChanges
      // .pipe(
      // filter(()  =>  this.productChoiceForm.valid)
      // )
      // .subscribe(res => {
      if (this.editMode) {
        if (this.productsChoice && this.selectedProductCode !== this.productsChoice['product']) {
          formChanged = true;
          this.showNext(formChanged);
        } else {
          formChanged = false;
          this.showNext(formChanged);
        }
      }
    }
  }
  validateProductSelection(): boolean {
    let rulesValid = false;
    this.ProductErrorValidatorFlag = !this.isProductSelected;
    if (!this.productChoiceForm.valid) {
      FormValidationsService.validateAllFormFields(this.productChoiceForm, this.analyticsService);
    }
    if (this.productChoiceForm.valid && !this.ProductErrorValidatorFlag) {
      rulesValid = true;
    }
    return rulesValid;
  }

  createQuestionarray(): any {
    const questionArray = [];
    if (this.productChoiceForm.controls.pensionPotQues.value) {
      questionArray.push({
        questionCode: 'pensionPotQuestion',
        // question: this.contentData.pensionPotQuestion.questionStatement,
        questionType: this.contentData.pensionPotQuestion.questionType,
        answer: this.productChoiceForm.controls.pensionPotQues.value
      });
    }
    if (this.productChoiceForm.controls.flexwithQues.value) {
      questionArray.push({
        questionCode: 'lumpSumsQuestion',
        // question: this.contentData.lumpSumsQuestion.questionStatement,
        questionType: this.contentData.lumpSumsQuestion.questionType,
        answer: this.productChoiceForm.controls.flexwithQues.value
      });
    }
    if (this.productChoiceForm.controls.financialDependantsQues.value) {
      questionArray.push({
        questionCode: 'financialDependantsQuestion',
        // question: this.contentData.financialDependantsQuestion.questionStatement,
        questionType: this.contentData.financialDependantsQuestion.questionType,
        answer: this.productChoiceForm.controls.financialDependantsQues.value
      });
    }
    if (this.productChoiceForm.controls.withdrawingMoneyQues.value) {
      questionArray.push({
        questionCode: 'withdrawingMoneyQuestion',
        // question: this.contentData.financialDependantsQuestion.questionStatement,
        questionType: this.contentData.withdrawingMoneyQuestion.questionType,
        answer: this.productChoiceForm.controls.withdrawingMoneyQues.value
      });
    }

    return questionArray;
  }
  gotoNextPage = () => {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Next', pageID: this.getCurrentScreenURL(), productChosen: this.selectedProductCode });
    this.analyticsService.selectedProductsTrack({ name: this.selectedProductCode })
    let formchanged = false;
    if (this.selectedProductCode !== this.productsChoice['product']) {
      formchanged = true;
    } else {
      formchanged = false;
    }

    if (this.validateProductSelection()) {
      if (this.editMode || this.userInputDetail.buttonConfig.name.toUpperCase() !== 'NEXT') {
        this.referenceNumber = {...this.referenceNumber, editMode: false};
        this.editMode = false;
        this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
        this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
        if (this.validateProductSelection()) {
          this.store.dispatch(new ProductChoiceActions.RemoveProductChoice(0));
          this.store.dispatch(new ProductChoiceActions.AddProductChoice({
            selectedProduct: this.selectedProductCode,
            // tslint:disable-next-line:max-line-length
            productName: this.selectedProductName ? this.selectedProductName : this.postProductChoice.productName, pensionPotQues: this.productChoiceForm.controls.pensionPotQues.value,
            flexwithQues: this.productChoiceForm.controls.flexwithQues.value,
            financialDependantsQues: this.productChoiceForm.controls.financialDependantsQues.value,
            withdrawingMoneyQues: this.productChoiceForm.controls.withdrawingMoneyQues.value,
            riskAndStaticQuestion: this.createQuestionarray(),
            source: this.productsChoice['source'],
            productOptions: this.productsChoice['productOptions']
          }));

          this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
            if (formchanged) {
              this.router.navigate([this.urlLink]);
            } else {
              this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
            }

          });
        } else {
          this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
        }
      } else {
        // ------------------------------------------Added Here-------------------------------------
        if (this.postProductChoice) {
          if (this.postProductChoice.selectedProduct !== this.selectedProductCode) {
            // tslint:disable-next-line:no-debugger
            if (this.yourOptions) {
              this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
              this.quoteDatacaptureService.requestQuoteCalculation = null;
            }
            if (this.yourOptionsResponse && this.yourOptionsResponse.benefitVariants && this.yourOptionsResponse.benefitVariants.length > 0) {
              // this.store.dispatch(new ResQuoteCalcActions.RemoveQuoteCalculation(0));
              this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
              this.quoteDatacaptureService.responseQuoteCalculation = null;
            }
            // tslint:disable-next-line: max-line-length
            // this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
            //   { ...this.quoteForm.value, calculatedTaxFreeLumSum: this.calculatedTaxFreeLumSum }
            // ));
          }
        }
        // ----------------------------------------------END----------------------------------------
        // adding form to store
        this.store.dispatch(new ProductChoiceActions.RemoveProductChoice(0));
        // tslint:disable-next-line: max-line-length
        this.store.dispatch(new ProductChoiceActions.AddProductChoice({
          selectedProduct: this.selectedProductCode,
          productName: this.selectedProductName, pensionPotQues: this.productChoiceForm.controls.pensionPotQues.value,
          flexwithQues: this.productChoiceForm.controls.flexwithQues.value,
          financialDependantsQues: this.productChoiceForm.controls.financialDependantsQues.value,
          withdrawingMoneyQues: this.productChoiceForm.controls.withdrawingMoneyQues.value,
          riskAndStaticQuestion: this.createQuestionarray(),
          source: this.productsChoice['source'],
          productOptions: this.productsChoice['productOptions']
        }));
        this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
          this.router.navigate([this.urlLink], { replaceUrl: true } );
        });
      }
    } else {
      FormValidationsService.validateAllFormFields(this.productChoiceForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }
  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }
  OnBackClick() {
    this.store.dispatch(new ProductChoiceActions.RemoveProductChoice(0));
    // tslint:disable-next-line: max-line-length
    this.store.dispatch(new ProductChoiceActions.AddProductChoice({
      selectedProduct: this.selectedProductCode,
      productName: this.selectedProductName, pensionPotQues: this.productChoiceForm.controls.pensionPotQues.value,
      flexwithQues: this.productChoiceForm.controls.flexwithQues.value,
      financialDependantsQues: this.productChoiceForm.controls.financialDependantsQues.value,
      withdrawingMoneyQues: this.productChoiceForm.controls.withdrawingMoneyQues.value,
      riskAndStaticQuestion: this.createQuestionarray(),
      source: this.productsChoice['source'],
      productOptions: this.productsChoice['productOptions']
    }));
  }
  alertPrimaryBtnClick() {
    this.closeModal();

  }

  alertSecondaryBtnClick() {
    this.closeModal();
  }
  closeModal() {
    this.displayAlert = false;
  }

  focusOnbtn() {
    this.btnFocusOnModalClose.scrollFlagState.subscribe(res => {
      if (res.scrollModalFlag) {
        this.previousActiveElement = document.activeElement;
      } else {
        if (this.previousActiveElement && this.previousActiveElement.id) {
          this.previousActiveElement.focus();
        }
      }
    });
  }

  /** Code block for CMS */
  GetCMSDataService() {
    //console.log('original value = ', this.contentData.products.find(q => q['productCode'] === 'H').documentLink.find(k => k['key'] === 'keyFeatures').name);

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourProductChoice;
    this.utilService.getCMSData(URL)
      .subscribe(res => {
        //console.log('2 GetCMSDataService => ', res);
        this.CMSData = res;
        if (this.CMSData) {
          /** In the line below we are over-writing the contentData object values with CMSData object values */
          this.contentData.header = this.CMSData.string_YourProductChoiceTitle;
          this.contentData.ageonHeader = this.CMSData.string_YourProductSingleTitle;
          this.contentData.subtitle = this.CMSData.string_YourProductChoiceWhichProduct;
          this.contentData.errorMessages = this.CMSData.string_SelectProductErrorMessage;
          /** Mappers for PA */
          this.contentData.products.find(q => q['productCode'] === 'C').productName = this.CMSData.string_PensionAnnuityProductTitle;
          this.contentData.products.find(q => q['productCode'] === 'C').productDescription = this.CMSData.string_PensionAnnuityDescription;
          this.contentData.products.find(q => q['productCode'] === 'C').docDescription = this.CMSData.string_KeyFeaturesTermsandConditionsTitle;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'keyFeatures').name =
            this.CMSData.pdfBlock.string_KeyfeaturesPdfTitle;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'Terms and conditions').name =
            this.CMSData.pdfBlock.string_TermsandConditionsPdfTitle;
          this.contentData.products.find(q => q['productCode'] === 'C').questionResponse[0].pensionPotQuestion.find(q => q['questionCode'] === 'N').infoText =
            this.CMSData.string_RiskQuestion_1PAWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'C').questionResponse[0].pensionPotQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_1PAWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'C').questionResponse[1].lumpSumsQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_2PAWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'C').questionResponse[1].lumpSumsQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_2PAWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'C').questionResponse[2].financialDependantsQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_3PAWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'C').questionResponse[2].financialDependantsQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_3PAWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'C').moreDetail[0].text = this.CMSData.string_PensionAnnuityMoreDetailsStatement1;
          this.contentData.products.find(q => q['productCode'] === 'C').moreDetail[1].text = this.CMSData.string_PensionAnnuityMoreDetailsStatement2;
          this.contentData.products.find(q => q['productCode'] === 'C').moreDetail[2].text = this.CMSData.string_PensionAnnuityMoreDetailsStatement3;
          this.contentData.products.find(q => q['productCode'] === 'C').moreDetail[3].text = this.CMSData.string_PensionAnnuityMoreDetailsStatement4;


          /** Mappers for FTRP */
          this.contentData.products.find(q => q['productCode'] === 'H').productName = this.CMSData.string_FTRPProductTitle;
          this.contentData.products.find(q => q['productCode'] === 'H').productDescription = this.CMSData.string_FTRPDescription;
          this.contentData.products.find(q => q['productCode'] === 'H').docDescription = this.CMSData.string_KeyFeaturesTermsandConditionsTitle;
          this.contentData.products.find(q => q['productCode'] === 'H').documentLink.find(k => k['key'] === 'keyFeatures').name =
            this.CMSData.pdfBlock.string_KeyfeaturesPdfTitle;
          this.contentData.products.find(q => q['productCode'] === 'H').documentLink.find(k => k['key'] === 'Terms and conditions').name =
            this.CMSData.pdfBlock.string_TermsandConditionsPdfTitle;
          this.contentData.products.find(q => q['productCode'] === 'H').questionResponse[0].pensionPotQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_1FTRPWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'H').questionResponse[0].pensionPotQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_1FTRPWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'H').questionResponse[1].lumpSumsQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_2FTRPWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'H').questionResponse[1].lumpSumsQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_2FTRPWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'H').questionResponse[2].financialDependantsQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_3FTRPWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'H').questionResponse[2].financialDependantsQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_3FTRPWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'H').moreDetail[0].text = this.CMSData.string_FTRPMoreDetailsStatement1;
          this.contentData.products.find(q => q['productCode'] === 'H').moreDetail[1].text = this.CMSData.string_FTRPMoreDetailsStatement2;
          this.contentData.products.find(q => q['productCode'] === 'H').moreDetail[2].text = this.CMSData.string_FTRPMoreDetailsStatement3;
          this.contentData.products.find(q => q['productCode'] === 'H').moreDetail[3].text = this.CMSData.string_FTRPMoreDetailsStatement4;

          /** Mappers for CORP */
          this.contentData.products.find(q => q['productCode'] === 'G').productName = this.CMSData.string_CORPProductTitle;
          this.contentData.products.find(q => q['productCode'] === 'G').productDescription = this.CMSData.string_CORPDescription;
          this.contentData.products.find(q => q['productCode'] === 'G').docDescription = this.CMSData.string_KeyFeaturesTermsandConditionsTitle;
          this.contentData.products.find(q => q['productCode'] === 'G').documentLink.find(k => k['key'] === 'keyFeatures').name =
            this.CMSData.pdfBlock.string_KeyfeaturesPdfTitle;
          this.contentData.products.find(q => q['productCode'] === 'G').documentLink.find(k => k['key'] === 'Terms and conditions').name =
            this.CMSData.pdfBlock.string_TermsandConditionsPdfTitle;
          // tslint:disable-next-line:max-line-length
          this.contentData.products.find(q => q['productCode'] === 'G').questionResponse[0].pensionPotQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_1FTRPWarningWording;
          // tslint:disable-next-line:max-line-length
          this.contentData.products.find(q => q['productCode'] === 'G').questionResponse[0].pensionPotQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_1CORPWarningWording;
          // tslint:disable-next-line:max-line-length
          this.contentData.products.find(q => q['productCode'] === 'G').questionResponse[0].pensionPotQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_1CORPWarningWording;
          // tslint:disable-next-line:max-line-length
          this.contentData.products.find(q => q['productCode'] === 'G').questionResponse[1].lumpSumsQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_2CORPWarningWording;
          // tslint:disable-next-line:max-line-length
          this.contentData.products.find(q => q['productCode'] === 'G').questionResponse[1].lumpSumsQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_2CORPWarningWording;
          // tslint:disable-next-line:max-line-length
          this.contentData.products.find(q => q['productCode'] === 'G').questionResponse[2].financialDependantsQuestion.find(q => q['questionCode'] === 'Y').infoText =
            this.CMSData.string_RiskQuestion_3CORPWarningWording;
          // tslint:disable-next-line:max-line-length
          this.contentData.products.find(q => q['productCode'] === 'G').questionResponse[2].financialDependantsQuestion.find(q => q['questionCode'] === 'U').infoText =
            this.CMSData.string_RiskQuestion_3CORPWarningWording;
          this.contentData.products.find(q => q['productCode'] === 'G').moreDetail[0].text = this.CMSData.string_CORPMoreDetailsStatement1;
          this.contentData.products.find(q => q['productCode'] === 'G').moreDetail[1].text = this.CMSData.string_CORPMoreDetailsStatement2;
          this.contentData.products.find(q => q['productCode'] === 'G').moreDetail[2].text = this.CMSData.string_CORPMoreDetailsStatement3;
          this.contentData.products.find(q => q['productCode'] === 'G').moreDetail[3].text = this.CMSData.string_CORPMoreDetailsStatement4;

          this.cmsDataQuestionWithdrawingMoney.questionStatement = this.CMSData.string_RiskQuestion_4GI;
          // tslint:disable-next-line:max-line-length
          this.cmsDataQuestionWithdrawingMoney.questionOptions.find(q => q['code'] === 'Y').infoText = this.CMSData.string_RiskQuestion_4GIWarning;
          // tslint:disable-next-line:max-line-length
          this.cmsDataQuestionWithdrawingMoney.questionOptions.find(q => q['code'] === 'U').infoText = this.CMSData.string_RiskQuestion_4GIWarning;

          /** End of Mappers for CORP */

          this.contentData.pensionPotQuestion.questionStatement = this.CMSData.string_RiskQuestion_1Wording;
          this.contentData.lumpSumsQuestion.questionStatement = this.CMSData.string_RiskQuestion_2Wording;
          this.contentData.financialDependantsQuestion.questionStatement = this.CMSData.string_RiskQuestion_3Wording;
          this.contentData.modalConfigProductChange.header = this.CMSData.string_ProductChangeWarningMessageTitle;
          this.contentData.modalConfigProductChange.content = this.CMSData.string_ProductChangeWarningMessageBody;
          this.contentData.introduction = this.CMSData.string_YourProductSingleSubTitle;
          if (this.productOption && this.productOption.length > 1) {
            this.contentData.introduction = this.CMSData.string_YourProductChoiceSubTitle;
          }
          // re-assign the risk questions to config
          this.cmsDataQuestionPensionPot = JSON.parse(JSON.stringify(this.contentData.pensionPotQuestion));
          this.cmsDataQuestionflexwith = JSON.parse(JSON.stringify(this.contentData.lumpSumsQuestion));
          this.cmsDataQuestionFinancialDependants = JSON.parse(JSON.stringify(this.contentData.financialDependantsQuestion));
          this.cmsDataQuestionWithdrawingMoney = JSON.parse(JSON.stringify(this.contentData.withdrawingMoneyQuestion));

          /** PDF Mappers */
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'Terms and conditions').url =
            this.CMSData.pdfBlock.externalUrl_TermsConditionsQ56660;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'I').url =
            this.CMSData.pdfBlock.externalUrl_InternalDirectKfQ56658;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'B').url =
            this.CMSData.pdfBlock.externalUrl_ExternalDirectKfQ56658;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(ele['fundingSource'])).url =
            this.CMSData.pdfBlock.externalUrl_ExternalDirectKfQ56658;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'H').url =
            this.CMSData.pdfBlock.externalUrl_AegonSltaKfQ58798;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'F').url =
            this.configLoaderService.configuration.isSlocRemoved ? this.CMSData.pdfBlock.PhoenixSimpPA_KFD_DA2125 : this.CMSData.pdfBlock.externalUrl_SlocSltaKfQ58799;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'O').url =
            this.CMSData.pdfBlock.PhoenixSimpPA_KFD_DA2125;
          this.contentData.products.find(q => q['productCode'] === 'C').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'J').url =
            this.CMSData.pdfBlock.externalUrl_ReassureSltaKfQ59212;

          /** CORP PDF mapper*/
          this.contentData.products.find(q => q['productCode'] === 'G').documentLink.find(k => k['key'] === 'Terms and conditions').url =
            this.CMSData.pdfBlock.corPlUrl_TermsConditionsQ0050902;
         // this.contentData.products.find(q => q['productCode'] === 'G').documentLink.find(k => k['key'] === 'keyFeatures').url =
         //   this.CMSData.pdfBlock.corpUrl_KFQ0050893;
         this.contentData.products.find(q => q['productCode'] === 'G').documentLink.find(k => k['key'] === 'keyFeatures').url =  (this.fundingSource === 'J')?  this.CMSData.pdfBlock.reAssureCORP_KFDURL_Q0059217 : this.CMSData.pdfBlock.corpUrl_KFQ0050893;
         //   this.CMSData.pdfBlock.corpUrl_KFQ0050893;
       //   this.contentData.products.find(q => q['productCode'] === 'G').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'J').url = (this.fundingSource === 'J')?  this.CMSData.pdfBlock.reAssureCORP_KFDURL_Q0059217 : this.CMSData.pdfBlock.corpUrl_KFQ0050893;


          /** FTRP PDF mapper*/
          this.contentData.products.find(q => q['productCode'] === 'H').documentLink.find(k => k['key'] === 'Terms and conditions').url =
            this.CMSData.pdfBlock.ftrpUrl_TermsConditionsQ0050905;
      //    this.contentData.products.find(q => q['productCode'] === 'H').documentLink.find(k => k['key'] === 'keyFeatures').url =
        //    this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898;
        this.contentData.products.find(q => q['productCode'] === 'H').documentLink.find(k => k['key'] === 'keyFeatures').url = (this.fundingSource === 'J')?  this.CMSData.pdfBlock.reAssureFTRP_KFDURL_Q0059214 : this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898;
        
        //  this.contentData.products.find(q => q['productCode'] === 'H').documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele => ele['fundingSource'] === 'J').url = (this.fundingSource === 'J')?  this.CMSData.pdfBlock.reAssureFTRP_KFDURL_Q0059214 : this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898;


          // this.userInputDetail['buttonConfig'].label = this.CMSData.commonBlock.string_NextCTALabel;
          this.alertModalEditConfig = new AlertModal('alert', this.CMSData.commonBlock.string_DependantRemovedPopUpTitle, this.CMSData.commonBlock.string_DependantRemovedPopUpText, this.CMSData.commonBlock.string_OKCTALabel, '', 'Don’t show this message again');
      //    //console.log('changed value = ', this.contentData.products.find(q => q['productCode'] === 'H').documentLink.find(k => k['key'] === 'keyFeatures').name);
        this.onPageLoadFunctionality();
        }
      });
  }

  /** End of code block for CMS */
  /** For web tracking */
  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return this.screenName;
  }

}
